import { apiFetch, parseApiResponse } from '../../../utils/apiClient';

export const buildPlanningQuery = (filters = {}) => {
  const query = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value === '' || value === null || value === undefined) return;
    const values = Array.isArray(value) ? value : [value];
    values.forEach((entry) => {
      if (entry === '' || entry === null || entry === undefined || (typeof entry === 'object' && !(entry instanceof Date))) return;
      query.append(key, entry instanceof Date ? entry.toISOString() : String(entry));
    });
  });
  const serialized = query.toString();
  return serialized ? `?${serialized}` : '';
};

const safePlanningError = (error) => {
  if (error.name === 'AbortError') return error;
  const message = String(error.message || 'Une erreur est survenue.');
  const unsafe = /<html|select\s.+from|insert\s+into|update\s.+set|at\s+\w+\s*\(|https?:\/\/|password|secret|token/i.test(message);
  const clean = unsafe || message.length > 400 ? 'Le service Planning a rencontré une erreur. Réessayez ou contactez un administrateur.' : message;
  return Object.assign(new Error(clean), { status: error.status });
};

const request = async (path, { body, ...options } = {}) => {
  try {
    const response = await apiFetch(path, { ...options, ...(body === undefined ? {} : { body: JSON.stringify(body) }) });
    return await parseApiResponse(response);
  } catch (error) {
    throw safePlanningError(error);
  }
};

export const getCaldavAccount = (options = {}) => request('/api/planning/account', options);
export const updateCaldavAccount = (payload, options = {}) => request('/api/planning/account', { ...options, method: 'PUT', body: payload });
export const testCaldavAccount = (payload, options = {}) => request('/api/planning/account/test', { ...options, method: 'POST', body: payload });
export const getPlanningEvents = (filters = {}, options = {}) => request(`/api/planning/events${buildPlanningQuery(filters)}`, options);
export const createPlanningEvent = (payload, options = {}) => request('/api/planning/events', { ...options, method: 'POST', body: payload });
export const updatePlanningEvent = (eventId, payload, options = {}) => request(`/api/planning/events/${encodeURIComponent(eventId)}`, { ...options, method: 'PUT', body: payload });
export const deletePlanningEvent = (eventId, { deleteExternal = false, ...options } = {}) => request(`/api/planning/events/${encodeURIComponent(eventId)}`, { ...options, method: 'DELETE', body: { deleteExternal: Boolean(deleteExternal) } });
export const getPlanningResources = (filters = {}, options = {}) => request('/api/users/GetUsers', options);
export const getPlanningCapacity = (filters = {}, options = {}) => request(`/api/workload/team${buildPlanningQuery(filters)}`, options);
export const syncPlanningEvent = (eventId, options = {}) => request(`/api/planning/events/${encodeURIComponent(eventId)}/sync`, { ...options, method: 'POST' });
export const importPlanningEvents = (payload = {}, options = {}) => request('/api/planning/events/import', { ...options, method: 'POST', body: payload });
